import { getActivityBasedFormFlowFactory } from "../form-flow-engine-initializer.js";
export async function invokeActivityBasedFormFlowAsync(formFlowDefinition, input, options) {
    const factory = getActivityBasedFormFlowFactory();
    const formFlow = await factory.build(formFlowDefinition, input, options);
    try {
        const startActivityId = formFlow.findStartActivityId();
        await formFlow.invokeActivity(startActivityId);
        const output = await extractOutputResultAsync(formFlowDefinition, formFlow);
        await formFlow.onComplete();
        return output;
    }
    catch (error) {
        if (factory.handleError(formFlow, error)) {
            return extractEmptyOutputResult(formFlowDefinition);
        }
        throw error;
    }
    finally {
        await factory.dispose(formFlow);
    }
}
async function extractOutputResultAsync(formFlowDefinition, formFlow) {
    if (formFlowDefinition.OutParameters) {
        const result = {};
        for (const outParam of formFlowDefinition.OutParameters) {
            const value = await formFlow.getVariableValue(outParam.Name);
            result[outParam.Name] = value;
        }
        return result;
    }
    return undefined;
}
function extractEmptyOutputResult(formFlowDefinition) {
    if (formFlowDefinition.OutParameters) {
        const result = {};
        for (const outParam of formFlowDefinition.OutParameters) {
            result[outParam.Name] = undefined;
        }
        return result;
    }
    return undefined;
}
